//@flow

import * as React from 'react';
import invariant from 'common/utils/invariant';
import { ProviderContext, type ProviderContextValue } from './ProviderContext';

export const useProvider = (): ProviderContextValue => {
    const context = React.useContext(ProviderContext);
    invariant(
        context,
        'Missing provider context. Make sure the corresponding provider is present.'
    );
    return context;
};
